import { render, staticRenderFns } from "./mtcLangListPopover.vue?vue&type=template&id=2c2490f4&"
import script from "./mtcLangListPopover.vue?vue&type=script&lang=js&"
export * from "./mtcLangListPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports